import { Dispatch } from 'redux';
import {
  PolicyNoteRequest,
  POLICY_NOTE_SUCCESS,
  POLICY_NOTE_START,
  POLICY_NOTE_FAILED,
  POLICY_NOTE_ADD_START,
  POLICY_NOTE_ADD_SUCCESS,
  POLICY_NOTE_ADD_FAILED
} from './types';
import { ApiClient } from '../api.client';
import { ReduxStore } from '../payload-types';
import { LINKS } from '@trip-ux/constants';

export const getPolicyNote = (policyNumber: string) => {
  return (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
    dispatch({ type: POLICY_NOTE_START });
    return apiClient(dispatch, getState)
      .get(`${LINKS.POLICY}/${policyNumber}/notes`)
      .then(payload => {
        return { ...payload, policyNumber };
      })
      .then(payload => {
        dispatch({ type: POLICY_NOTE_SUCCESS, payload });
      })
      .catch(e => {
        dispatch({ type: POLICY_NOTE_FAILED, payload: e });
      });
  };
};

export const addNewNote =
  (payload: PolicyNoteRequest) =>
  (dispatch: Dispatch, getState: () => ReduxStore, apiClient: ApiClient): Promise<void> => {
    dispatch({ type: POLICY_NOTE_ADD_START });
    return apiClient(dispatch, getState)
      .post(`${LINKS.POLICY}/${payload.ownerCode}/note`, payload)
      .then(() => {
        dispatch({ type: POLICY_NOTE_ADD_SUCCESS });
        getPolicyNote(payload.ownerCode)(dispatch, getState, apiClient);
      })
      .catch(e => {
        dispatch({ type: POLICY_NOTE_ADD_FAILED, payload: e });
      });
  };